<template>
  <validation-provider
    :name="name"
    :vid="name"
    v-slot="validation"
    ref="provider"
    tag="div"
  >
    <div :class="$style.container">
      <div
        :class="{
          [$style.field]: true,
          [$style.hasError]: validation.errors[0],
          [$style.valid]: validation.valid === true
        }"
        ref="cardField"
      ></div>
      <div :class="$style.error">{{ validation.errors[0] }}</div>
    </div></validation-provider
  >
</template>

<script>
import { ValidationProvider } from 'vee-validate'

import stripe from '@/services/stripe'

export default {
  name: 'base-credit-card-input',

  components: { ValidationProvider },

  props: {
    name: { type: String, default: 'cardField' }
  },

  data: () => ({ card: null }),

  methods: {
    handleValidation({ error, complete }) {
      this.$refs.provider.applyResult({
        errors: error
          ? [error.message]
          : !complete
          ? ['Card information is incomplete']
          : [],
        valid: !error && !!complete,
        failedRules: {}
      })
    }
  },

  mounted() {
    this.card = stripe.createCardField(this.$refs.cardField, {
      classes: {
        complete: this.$style.complete,
        invalid: this.$style.invalid,
        focus: this.$style.hasFocus,
        base: this.$style.field
      }
    })
    this.card.addEventListener('change', this.handleValidation)
  },

  destroyed() {
    this.card.removeEventListener('change', this.handleValidation)
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: spacing(2);
}

.field {
  box-shadow: 0 -3px 0 -2px #c2c4c6 inset;
  width: 100%;
  font-family: $font-primary;
  font-size: $size-medium;
  font-weight: $weight-regular;
  line-height: 1.5;
  padding: 18.41px spacing(2);
  color: $color-copy;
  background: $color-fields;
  border: none;
}

.hasFocus,
.hasError,
.complete,
.invalid,
.valid {
  background-color: rgba(0, 143, 202, 0.1);
}

.complete,
.valid {
  box-shadow: 0 -4px 0 -2px $color-success inset;
}

.hasError,
.invalid {
  box-shadow: 0 -4px 0 -2px $color-danger inset;
}

.error {
  font-size: $size-xx-small;
  font-weight: $weight-medium;
  line-height: $size-medium;
  letter-spacing: 0.4px;
  color: $color-danger;
  min-height: spacing(2);
  margin-left: spacing(2);
  margin-top: 2px;
  text-align: left;
}
</style>
